export default {"src":"/org/_next/static/media/link.52985e98.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};